/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ResetIcon } from '@popety_io/popety-io-lib'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Switch from '@mui/material/Switch'
import EditIcon from '@mui/icons-material/Edit'
import SaveIcon from '@mui/icons-material/Save'
import CloseIcon from '@mui/icons-material/Close'
import Tooltip from '@mui/material/Tooltip'

const GridHeader = ({
  title,
  withMargin = true,
}: {
  title: string
  withMargin?: boolean
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBlock: withMargin ? '10px' : '0',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          marginBottom: '4px',
          fontSize: '1.1rem',
          textTransform: 'uppercase',
        }}
      >
        {title}
      </Typography>
    </Box>
  )
}

export default GridHeader
